import { SeqPaletteBase } from './seq-palettes';
export class NucleotidesPalettes extends SeqPaletteBase {
    static get Chromatogram() {
        if (this.chromatogram === void 0) {
            this.chromatogram = new NucleotidesPalettes({
                'A': 'green',
                'C': 'blue',
                'G': 'black', // orange ?
                'T': 'red',
                'U': 'red',
                'others': 'gray',
            });
        }
        return this.chromatogram;
    }
}
export class Nucleotides {
}
Nucleotides.SemType = 'Nucleotides';
Nucleotides.SemTypeMultipleAlignment = 'NucleotidesMultipleAlignment';
Nucleotides.Names = {
    'A': 'Adenine',
    'C': 'Cytosine',
    'G': 'Guanine',
    'T': 'Thymine',
    'U': 'Uracil',
};
//# sourceMappingURL=nucleotides.js.map